import React from "react";
import { PriorityChip, StatusChip } from "./Chips";
import {
  AntiguedadCell,
  CadeteCell,
  ComercioCell,
  DuracionCell,
  EstadoCell,
  FinCadeteCell,
  Muted,
  PedidaEntregadaCell,
  ResponsableCell,
  UltimaEntregaCell,
  isCancelada,
  isSpotlight,
  motivoLabel,
  newBadge,
} from "./rolloCells";
import { EMPTY, formatDate, rollosWord } from "../rolloFormat";

const Meta = ({ label, full = false, children }) => (
  <div className={full ? "crm-rollo__card-full" : undefined}>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
);

function ActivaCard({ item, currentUserId, busy, spotlight, diasParaDemora, renderActions }) {
  const cantidad = Number(item.cantidadSolicitada) || 0;
  const badge = newBadge(item, spotlight);
  const className = ["crm-rollo__card", busy ? "is-busy" : "", isSpotlight(item, spotlight) ? "is-spotlight" : "", badge ? "is-new" : ""]
    .filter(Boolean)
    .join(" ");
  return (
    <article className={className} aria-busy={busy || undefined}>
      <div className="crm-rollo__card-head">
        <div>
          <ComercioCell item={item} compact badge={badge} />
        </div>
        <PriorityChip prioridad={item.prioridad} />
      </div>
      <div>
        <EstadoCell item={item} />
      </div>
      <dl className="crm-rollo__card-meta">
        <Meta label="Cantidad">
          <b>{cantidad}</b> {rollosWord(cantidad)}
        </Meta>
        <Meta label="Antigüedad">
          <AntiguedadCell item={item} diasParaDemora={diasParaDemora} />
        </Meta>
        <Meta label="Última entrega">
          <UltimaEntregaCell item={item} />
        </Meta>
        <Meta label="Cadete">
          <CadeteCell item={item} />
        </Meta>
        <Meta label="Responsable" full>
          <ResponsableCell item={item} currentUserId={currentUserId} compact />
        </Meta>
      </dl>
      {item.proximaAccion ? (
        <div className="crm-rollo__card-next">
          <span className="crm-rollo__lbl">Próx. acción</span>
          <div>
            {item.proximaAccion}
            {item.fechaProximaAccion ? (
              <>
                {" · "}
                <Muted>{formatDate(item.fechaProximaAccion)}</Muted>
              </>
            ) : null}
          </div>
        </div>
      ) : null}
      {renderActions(item, true)}
    </article>
  );
}

function FinalizadaCard({ item, currentUserId, renderActions }) {
  const cancelada = isCancelada(item);
  return (
    <article className="crm-rollo__card">
      <div className="crm-rollo__card-head">
        <div>
          <ComercioCell item={item} compact />
        </div>
        <StatusChip estado={item.estado} />
      </div>
      <dl className="crm-rollo__card-meta">
        <Meta label="Pedida / entregada">
          <PedidaEntregadaCell item={item} />
        </Meta>
        <Meta label="Duración">
          <DuracionCell item={item} />
        </Meta>
        <Meta label="Pedido">{formatDate(item.createdAt)}</Meta>
        <Meta label="Cierre">{formatDate(item.fechaCierre)}</Meta>
        <Meta label="Cadete">
          <FinCadeteCell item={item} />
        </Meta>
        <Meta label={cancelada ? "Motivo" : "Recibió"}>{cancelada ? motivoLabel(item) : item.recibioNombre || EMPTY}</Meta>
        <Meta label="Responsable" full>
          <ResponsableCell item={item} currentUserId={currentUserId} compact />
        </Meta>
      </dl>
      {renderActions(item, true)}
    </article>
  );
}

// MobileCard list (design RolloMobile): same data and reading order as the table rows.
export default function QueueCards({
  items,
  finalizadas,
  currentUserId,
  busyId,
  spotlight = null,
  diasParaDemora = null,
  renderActions,
}) {
  return (
    <div className="crm-rollo__cards">
      {items.map((item) =>
        finalizadas ? (
          <FinalizadaCard key={item.id} item={item} currentUserId={currentUserId} renderActions={renderActions} />
        ) : (
          <ActivaCard
            key={item.id}
            item={item}
            currentUserId={currentUserId}
            busy={busyId === item.id}
            spotlight={spotlight}
            diasParaDemora={diasParaDemora}
            renderActions={renderActions}
          />
        )
      )}
    </div>
  );
}
